<div class="row page-titles">
  <div class="col-md-5 col-8 align-self-center">
      <h3 class="text-themecolor m-b-0 m-t-0">{{ titulo }}</h3>
      <ol class="breadcrumb">
          <li class="breadcrumb-item"><a>Home</a></li>
          <li class="breadcrumb-item active">{{ titulo }}</li>
      </ol>
  </div>

</div>
